import { type FC } from "react";

import { useDeepRootSelector } from "@ds/hooks";

import { AggregatedValue } from "@ds/components/entities";
import { IconType } from "@ds/components/icons";
import { InfoAttribute, InfoSection, InfoView, InfoViewCallToAction } from "@ds/components/info-view";
import { getInfoViewTitle } from "@ds/components/info-view/helpers";
import { getProperty } from "@ds/utils/properties";

import { formatMixingStrategy } from "../utils/helpers";
import { selectAggregatedCampaignForSelectedEntities } from "../redux/selectors";

export const CampaignInfo: FC<{ onCreateCampaign: () => void }> = ({ onCreateCampaign }) => {
  const aggregatedCampaign = useDeepRootSelector(selectAggregatedCampaignForSelectedEntities);
  if (aggregatedCampaign) {
    return (
      <InfoView
        infoTitle={getInfoViewTitle(aggregatedCampaign)}
        infoDescription={<AggregatedValue entity={aggregatedCampaign} field="description" />}
      >
        <InfoSection title="Campaign Info" icon="pi pi-info-circle">
          <InfoAttribute
            name="Mixing Strategy"
            value={
              <AggregatedValue
                entity={aggregatedCampaign}
                field="mixing_strategy"
                formatter={(entity, field) => formatMixingStrategy(getProperty(entity, field))}
              />
            }
          />
          <InfoAttribute
            name="# Items"
            value={<AggregatedValue entity={aggregatedCampaign} field="campaign_items_count" />}
          />
        </InfoSection>
      </InfoView>
    );
  }

  return (
    <InfoViewCallToAction
      infoTitle="Select campaign"
      callToActionText="Select a campaign in the table for more info or proceed with creating a new campaign."
      buttonLabel="Create campaign"
      buttonIcon={IconType.Create}
      onActionButtonClick={onCreateCampaign}
    />
  );
};
